var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#people_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.592 2.403A3.03 3.03 0 0 1 8.96 4.649a2.3 2.3 0 0 0 1.001.23c1.31 0 2.37-1.092 2.37-2.44S11.27 0 9.96 0C8.664 0 7.612 1.073 7.592 2.403M4.04 7.399c1.309 0 2.37-1.093 2.37-2.44 0-1.348-1.061-2.44-2.37-2.44s-2.37 1.092-2.37 2.44 1.061 2.44 2.37 2.44m1.005.166H3.034C1.361 7.565 0 8.966 0 10.689v2.532l.006.04.17.054C1.772 13.83 3.16 14 4.3 14c2.23 0 3.523-.655 3.603-.696l.158-.083h.017V10.69c0-1.723-1.36-3.124-3.034-3.124m5.92-2.519H8.972a3.05 3.05 0 0 1-.902 2.094c1.487.456 2.576 1.876 2.576 3.553v.78c1.97-.074 3.105-.65 3.18-.688l.158-.082H14V8.17c0-1.723-1.361-3.124-3.034-3.124"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "people_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export { SvgPeople as ReactComponent };
export default __webpack_public_path__ + "static/media/people.82668087.svg";